<template>
    <div
        v-if="!$wait.is('loading-page')"
        class="m-contact"
    >
        <y-container
            v-for="index in $settings('contact_details.elements').length"
            :key="`contact_details.elements_${index - 1}`"
        >
            <y-row
                class="my-10"
                :row-reverse="!!((index - 1) %2)"
            >
                <y-col md="5">
                    <h3 class="type-h3 mb-10">
                        {{ $t('contact.contact_title') }}
                    </h3>
                    <y-contact-info
                        v-if="$settings('contact_details')"
                        type="informed"
                        :branch="index"
                        :content="$settings('contact_details')"
                    />
                </y-col>

                <y-col
                    v-if="location(index - 1)"
                    md="7"
                >
                    <h3 class="mb-10 d-flex align-items-center">
                        <span class="type-h3 ml-2">{{ $t('contact.map', [$settings(`contact_details.elements.${index - 1}.branch_name.${$i18n.locale}`)]) }}</span>
                        <y-button
                            icon="map-marked-alt"
                            size="xsmall"
                            tag="a"
                            :href="`https://maps.google.com/?q=${location(index - 1).lat},${location(index - 1).long}`"
                            target="_blank"
                            rel="noopener noreferrer"
                            color="primary"
                            outline
                            text
                        />
                    </h3>
                    <y-map
                        height="500px"
                        :lat="location(index - 1).lat"
                        :lng="location(index - 1).long"
                        :marker="`${location(index - 1).lat},${location(index - 1).long}`"
                        :marker-icon="require(`@/assets/images/map-marker-${$i18n.locale}.svg`)"
                        :icon-size="[130, 70]"
                        :icon-anchor="[63, 53]"
                    />
                </y-col>
            </y-row>
        </y-container>
    </div>
</template>

<script>
    // Mixins
    import PageMixin from '@nodes/mixins/Page';

    // Components
    import {
        YMap, YRow, YCol, YContainer,
    } from '@components/index';
    import { YContactInfo } from '@rogues/ContactInfo';

    export default {

        name: 'ContactPage',

        components: {
            YMap,
            YContactInfo,
            YRow,
            YCol,
            YContainer,
        },

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                pageTitle: this.$t('contact.title'),
            };
        },

        methods: {
            /**
             * Return location object
             * 
             * @param {number} index
             * @returns {object | null}
             */
            location(index) {
                return this.$settings(`contact_details.elements.${index}.location.${this.$i18n.locale}`);
            },
        },

    };
</script>
